import { jsx as _jsx } from "react/jsx-runtime";
import { cn } from "../../../utils";
/**
 * The overlay a chat surface draws while a file is dragged over it — pair it
 * with `useFileDrop`'s `isDraggingOver`.
 *
 * It fills its nearest positioned ancestor, so that ancestor must be the drop
 * target itself. `z-20` clears the panel chrome a host may put on top of its
 * own transcript (Bliksy's resize handle sits at `z-10`).
 */ export function AiChatDropHint({ label = "Drop a file to attach it", className }) {
    return /*#__PURE__*/ _jsx("div", {
        "data-slot": "ai-chat-panel-drop-hint",
        className: cn("pointer-events-none absolute inset-2 z-20 flex items-center justify-center", "rounded-xl border-2 border-dashed border-primary/60 bg-background/80", "text-sm font-medium text-foreground", className),
        children: label
    });
}

//# sourceMappingURL=ai-chat-drop-hint.js.map